import {useTranslation} from 'react-i18next';
import QuestionMarkAndText from 'components/common/QuestionMarkAndText';
import ModalSheet from 'components/common/ModalSheet';
import {ModalSheetContainer, WhyDataRequiredText, ViewPrivacyPolicyLink} from './styled';
import {useModalControls} from '@chekin/guestapp-ui-kit';

type Props = {
  className?: string;
};
export const WhyDataRequired = ({className}: Props) => {
  const {t} = useTranslation();
  const {
    isOpen: isSignatureModal,
    openModal: openSignatureModal,
    closeModal: closeSignatureModal,
  } = useModalControls();

  return (
    <>
      <QuestionMarkAndText
        className={className}
        text={t('why_all_this_data_is_required')}
        onClick={openSignatureModal}
        iconSize={19}
      />
      <ModalSheet
        isOpenModalSheet={isSignatureModal}
        handleCloseModal={closeSignatureModal}
        title={t('why_all_this_data_is_required')}
        closeOnDocumentClick
        withCloseButton
        padding
        closeButtonType="click"
      >
        <ModalSheetContainer>
          <WhyDataRequiredText>{t('according_to_the_local_law')}</WhyDataRequiredText>
          <WhyDataRequiredText>{t('completing_online_checkin')}</WhyDataRequiredText>
          <WhyDataRequiredText>{t('personal_data_handling')}</WhyDataRequiredText>
          <ViewPrivacyPolicyLink
            href={t('guest_privacy_policy_link')}
            label={t('view_privacy_policy')}
          />
        </ModalSheetContainer>
      </ModalSheet>
    </>
  );
};
